<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1">Blackstone (See Woonsocket)</a></p>
<p class="toc"><a href="#/Chapter2">Burrillville</a></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">Cumberland</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">Glocester</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">Lincoln</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">North Smithfield</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">Pawtucket</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">Providence</span></p>
<p class="toc"><span href="#/Chapter9" title="Link target outside of Sample">Smithfield</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">Upton</span></p>
<p class="toc"><span href="#/Chapter11" title="Link target outside of Sample">Uxbridge</span></p>
<p class="toc"><span href="#/Chapter12" title="Link target outside of Sample">Woonsocket</span></p>
<p class="toc"><span href="#/Chapter13" title="Link target outside of Sample">Worcester</span></p>
<p class="toc"><span href="#/Chapter14" title="Link target outside of Sample">By the Way</span></p>
<p class="toc"><span href="#/Chapter15" title="Link target outside of Sample">Paxton</span></p>
<p class="toc"><span href="#/Chapter16" title="Link target outside of Sample">A Day to Remember</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?f52c396e